import React from "react";

// Activity name + guideline, or an "Other" tag with the member's custom description.
export default function ActivityLabel({ c, className = "" }) {
  return (
    <div className={className} data-testid={`thespian-activity-label-${c.id}`}>
      <p className="text-sm font-medium text-slate-800">
        {c.is_other && <span className="mr-1.5 inline-flex rounded-full bg-amber-100 px-1.5 py-0.5 align-middle text-[10px] font-bold uppercase tracking-wide text-amber-800" data-testid={`thespian-other-tag-${c.id}`}>Other</span>}
        {c.activity_name}
      </p>
      <p className="text-xs text-slate-400">{c.is_other ? c.activity_description : c.activity_guideline}</p>
    </div>
  );
}
